import React, { useEffect, useState } from 'react';
import { FaRunning } from "react-icons/fa";
import { format } from 'date-fns';
import { FaPlay, FaSquareFull, FaSync, FaGhost } from "react-icons/fa";

const Dash = ({farmno, server }) => {
  const [robostat, setRobo] = useState(null);
  const [robomsg, setMsg] = useState("Loading...");

  const fetchMetrics = () => {
    // retrieve and then setData()
    fetch(`https://${server}.cherry2024.com:2096/serverBots`)
      .then(response => response.json())
      .then(robostat => setRobo(robostat))
      .catch(error => setMsg(`Akamai Server is Unresponsive`));
  }

  useEffect(() => {
    fetchMetrics();
  }, []);

  // Bot Detail control
  function botstop(farm) {
    // setStat3(botno);
    // setStat2(`${new Date().toLocaleString()} Stopping`);
    //fetchMetrics();
    fetch(`https://${server}.cherry2024.com:2096/cherryoff?farmno=${farm}`)
      .then(response => response.json())
      .then(fetchMetrics())
      .catch(error => console.error(error));
  }
  function botstart(farm) {
    // setStat3(botno);
    // setStat2(`${new Date().toLocaleString()} Starting`);
    //fetchMetrics();
    fetch(`https://${server}.cherry2024.com:2096/cherryon?farmno=${farm}`)
      .then(response => response.json())
      .then(fetchMetrics())
      .catch(error => console.error(error));
  }

  return (
    <div className="shortline">
      {robostat ?
        <div>
          <span className="detailtxt">
            <button className="farmbuttonspacing btn btn-sm btn-outline-info up" title={server + " START"} onClick={() => botstart(farmno)}>Start&nbsp;&nbsp;<FaPlay /></button>
            <button className="farmbuttonspacing btn btn-sm btn-outline-info down" title={server + " STOP"} onClick={() => botstop(farmno)}>Stop&nbsp;&nbsp;&nbsp;<FaSquareFull /></button>
            &nbsp;
            {server}
          </span>
          <span className="runningman detailtxt"><FaRunning /></span>
          <span>
            {JSON.parse(robostat[0].json_result)
              .filter(server => server.farm === farmno)
              .map((item, index) => (
                <span key={item.stat} className=" biginfo" title={format(new Date(item.stat.split(":")[0] * 1000).toString(), 'eee HH:mm')}>
                  {(item.stat.split(":")[1] === 'on') && <span className="up dashstat" >&nbsp;{item.stat.split(":")[1]}</span>}
                  {(item.stat.split(":")[1] === 'off') && <span className="down dashstat" >&nbsp;{item.stat.split(":")[1]}</span>}
                </span>
              ))
            }
          </span>
          &nbsp;&nbsp;<button className="btn btn-sm fresh" title="REFRESH" onClick={() => fetchMetrics()}>&nbsp;<FaSync />&nbsp;</button>
        </div>
        :
        <span className="row">
          
          {(robomsg==="Loading...")
            ? <span>{robomsg}</span>
            : <span><FaGhost />&nbsp;{robomsg}&nbsp;<FaGhost /> </span>
          }

          
         </span>
      }
    </div>

  );
};

export default Dash;


